import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-customer-service-2-line"></i>
            <span>联系我们</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            {contactData.title}
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            {contactData.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
          {contactData.sections.map((sec, idx) => (
            <div key={idx} className="bg-background-100 rounded-xl p-5 md:p-6 text-center cursor-pointer hover:-translate-y-1 transition-all duration-200">
              <div className="w-12 h-12 mx-auto rounded-full bg-primary-100/80 text-primary-600 flex items-center justify-center mb-4">
                <i className={`${sec.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2">{sec.title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{sec.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}